import { type } from 'type-r'

export function parseBool(val) {
    if (typeof val == 'string') {
        if (!val || val == '0' || val == 'false')
            return false;
        else
            return true;
    }
    else if (typeof val == 'number') {
        return val != 0;
    }
    else if (typeof val == 'boolean')
        return val;
}
export function boolCheck(v) {
    if (v === null)
        return false;
    return true;
}
var PowerBool = type(Boolean).parse(parseBool).check(boolCheck, 'Required').value(null);
export default PowerBool;
